module.exports = __webpack_public_path__ + "static/media/Paypal.41ceaf14.svg";